import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4879929c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "start-shade"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "code-space" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card" }, null, -1))
const _hoisted_5 = { class: "contant" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "预约咨询", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "扫描下方二维码，添加八爪招生营销专家微信", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/cardcode.png",
  alt: "二维码"
}, null, -1))
const _hoisted_9 = ["hidden", "height", "src"]
const _hoisted_10 = ["hidden", "height", "src"]
const _hoisted_11 = { class: "right-list fr" }
const _hoisted_12 = { class: "header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo.png" }, null, -1))
const _hoisted_14 = { class: "menu-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "secondary"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "on-mobile counselling-btn" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/counselling.png",
  alt: "咨询"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "联系", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "我们", -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "counselling-tip" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/counsellingback.png",
    class: "back",
    alt: "预约咨询"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/counsellingcode.png",
    class: "code",
    alt: "八爪教育"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "扫描或长按识别上方二维码，添加八爪招生营销专家微信", -1))

import { ref,onMounted,computed } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { ifraUrl } from "@/utils/global";
  import { key } from "../store";
  import { wxSchema } from "@/request/api";
  interface settledConfig {
      flag: boolean;
      type: number;
  }
  interface menuConfig {
    name?: string;
    type?: number;
  }
  // 移动端-跳转路由
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AllPopups',
  setup(__props) {

  let store = useStore(key);
  const router = useRouter();

  const userPath = ref("");
  let data = {
    type: 1,
    path: "/pages/Settled/index",
    env_version: "release",
  }
  wxSchema(data).then((res:any)=>{
    userPath.value = res.openlink
  })

  // PC-关闭入驻弹窗
  const handleClose = (done: () => void)=>{
    settledActive({flag:false,type:0})
    done()
  }

  // PC端-咨询弹窗
  let reservationFlag = computed(()=>{
      return store.state.reservationFlag
  }) 
  // PC端-关闭咨询弹窗
  const reservationActive = (flag:boolean)=>{
      store.commit("reservationShow",flag);
  }
  // PC端-入驻
  const settledFlag = computed(()=>{
      return store.state.settledFlag
  }) 
    // settledType 1、机构；2、服务商
  const settledType = computed(()=>{
    return store.state.settledType;
  }) 
  // PC端-入驻-窗口高度
  const settledHeight = ref('500px');
  function onResize(){
    settledHeight.value = (window.innerHeight*0.8) + 'px';
  }
  
  // PC端-入驻弹窗
  const settledActive = (obj:settledConfig)=>{
      store.commit("settledActive",obj);
  }
  // 入驻-加载
  const isLoading = ref(true);
  const handleIframeLoad = ()=> {
    isLoading.value = false;
  }

  // 移动端-菜单弹窗
  let menuPhoneFlag = computed(()=>{
      return store.state.menuPhoneFlag
  }) 
  // 移动端-关闭菜单弹窗
  const menuPhoneActive = (flag:boolean)=>{
      store.commit("menuPhoneShow",flag);
  }

  // 移动端-咨询弹窗
  let counsellingFlag = computed(()=>{
      return store.state.counsellingFlag
  })
  
  // 移动端-咨询弹窗
  const counsellingPhoneActive = (flag:boolean)=>{
      store.commit("counsellingPhoneShow",flag);
  }

  // 移动端-返回顶部
  const backTop = () => {
    let top = document.documentElement.scrollTop; //获取点击时页面的滚动条纵坐标位置
    const timeTop = setInterval(() => {
      document.documentElement.scrollTop = top -= 50; //一次减50往上滑动
      if (top <= 0) {
        clearInterval(timeTop);
      }
    }, 5)//定时调用函数使其更顺滑
  }

  // 移动端-菜单
  const menuList = ref([
    {title: '关于八爪', name: 'octopus'},
    {title: '产品服务', children:[
      {title: '八爪畅学用户端', name: 'consumer'},
      {title: '八爪畅学机构端', name: 'mechanism'},
      {title: '八爪优服', name: 'serve'},
    ]},
    {title: '新闻中心', name: 'newsList'},
    {title: '机构入驻', type: 1},
    {title: '服务商入驻', type: 2},
  ])

  const targetPage = (item:menuConfig)=>{
    item.name && router.push({ name: item.name });
    switch(item.type){
      case 1: // 机构入驻
        userPath.value && window.open(userPath.value)
        break;
      case 2: // 服务商入驻
        counsellingPhoneActive(true)
        break;
      default:
        break;
    }
    menuPhoneActive(false); // 关闭弹窗
  }

  // 开场动画
  let startShade = ref(true);
  onMounted(() => {
  // 开场动画
    const timer = setTimeout(()=>{
      startShade.value = false;
      clearTimeout(timer);
    },2500);
    
    // PC端-入驻-弹窗高度
    onResize();
    window.addEventListener("resize",onResize);
  })


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(startShade))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: 'https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/start.gif?='+(new Date()),
            alt: "logo"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_unref(reservationFlag))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "reservation-mask",
          onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", {
                class: "icon-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (reservationActive(false)))
              }),
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: settledFlag.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settledFlag).value = $event)),
      "append-to-body": "",
      "before-close": handleClose,
      width: "80%",
      top: "5vh"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("iframe", {
            hidden: settledType.value === 2,
            name: "src",
            width: "100%",
            height: settledHeight.value,
            src: _unref(ifraUrl) + 'org/#/ruzhu',
            frameborder: "0",
            scrolling: "auto",
            onLoad: handleIframeLoad
          }, "暂不支持此浏览器", 40, _hoisted_9),
          _createElementVNode("iframe", {
            hidden: settledType.value === 1,
            name: "src",
            width: "100%",
            height: settledHeight.value,
            src: _unref(ifraUrl) + 'superior/#/ruzhu',
            frameborder: "0",
            scrolling: "auto",
            onLoad: handleIframeLoad
          }, "暂不支持此浏览器", 40, _hoisted_10)
        ])), [
          [_directive_loading, isLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(menuPhoneFlag))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "menu-mask",
          onTouchmove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"])),
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (menuPhoneActive(false)), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("img", {
                src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/close.png",
                class: "fr",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (menuPhoneActive(false)))
              })
            ]),
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (!item.children || item.children.length == 0)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        onClick: ($event: any) => (targetPage(item))
                      }, _toDisplayString(item.title), 9, _hoisted_15))
                    : (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _createElementVNode("div", null, _toDisplayString(item.title), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (elem, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: i,
                            onClick: ($event: any) => (targetPage(elem))
                          }, _toDisplayString(elem.title), 9, _hoisted_17))
                        }), 128))
                      ]))
                ]))
              }), 128))
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", {
        class: "link",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (counsellingPhoneActive(true)))
      }, _hoisted_22),
      _createElementVNode("div", {
        class: "top",
        onClick: backTop
      })
    ]),
    (_unref(counsellingFlag))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "counselling-mask",
          onTouchmove: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createTextVNode("预约咨询"),
              _createElementVNode("img", {
                src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/close.png",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (counsellingPhoneActive(false)))
              })
            ]),
            _hoisted_25,
            _hoisted_26
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}
}

})